var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre-cart-actions"},[_c('Button',{staticClass:"pre-cart-action-button",attrs:{"title":"商品選定を休憩する","is-primary":""},on:{"onClick":_vm.handleRestShopping}}),_c('Button',{staticClass:"pre-cart-action-button",attrs:{"title":"途中から始める"},on:{"onClick":_vm.handleRestoreCart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }